import { type FragmentOf, readFragment } from "@opensea/graphql"
import type { EVMAddress } from "@opensea/utils"
import { EXPIRATION_IN_MINUTES } from "../../../../lib/zod/expiration"
import type { CollectionOffer, CreateCollectionOfferFormValues } from "../types"
import { constructCollectionOffer_collectionFragment } from "./constructCollectionOffer.fragment"

export const constructCollectionOffer = ({
  collection: collectionKey,
  formValues,
}: {
  collection: FragmentOf<typeof constructCollectionOffer_collectionFragment>
  formValues: CreateCollectionOfferFormValues | undefined
}): Omit<CollectionOffer, "address"> | null => {
  if (!formValues) {
    return null
  }

  const collection = readFragment(
    constructCollectionOffer_collectionFragment,
    collectionKey,
  )
  const { expiration, offers } = formValues
  const firstOffer = offers[0]
  if (!firstOffer) {
    return null
  }

  const { price, quantity, trait, traits } = firstOffer
  const contractAddress = collection.chain.offerCurrency.address

  return {
    criteria: {
      chain: collection.chain.identifier,
      slug: collection.slug,
      contractAddress: collection.address as EVMAddress,
      trait,
      traits,
    },
    quantity,
    startTime: new Date(),
    endTime:
      expiration.expirationType === "custom"
        ? (expiration.customExpiration as Date)
        : new Date(
            Date.now() +
              EXPIRATION_IN_MINUTES[expiration.expirationType] * 60 * 1000,
          ),
    pricePerItem: {
      unit: price,
      contractAddress: contractAddress as EVMAddress,
    },
  }
}
